// app
import { useAuth } from '~/entities/auth'
import { DeviceType, useUpdateUserOnlineStatusMutation } from '~/shared/api'
import { useNotificationStore } from '~/shared/lib'

export default defineNuxtPlugin(() => {
  const { notify } = useNotificationStore()
  const { mutate: updateOnlineStatusMutation }
    = useUpdateUserOnlineStatusMutation()
  const { isAuthenticated } = useAuth()
  let interval: ReturnType<typeof setInterval>

  function checkConnection() {
    if (!navigator.onLine) {
      notify({ message: 'Нет интернета', type: 'error' })
    }
  }

  function updateOnlineStatus() {
    updateOnlineStatusMutation({ input: { deviceType: DeviceType.Desktop } })
  }

  // listeners
  window.addEventListener('offline', checkConnection)
  window.addEventListener('online', () => {
    notify({ message: 'Интернет восстановлен', type: 'success' })
  })
  watch(
    isAuthenticated,
    (value: boolean) => {
      if (value) {
        interval = setInterval(() => {
          updateOnlineStatus()
        }, 10000)
      }
      else {
        clearInterval(interval)
      }
    },
    { immediate: true },
  )

  checkConnection()
})
